/* Jagdish Store — Wallpaper made-to-measure calculator. Rev 1.0, 19 Sep 2026.

   Rev 1.1, 10 Oct 2026 (AK): the CALL number and the WhatsApp number are no longer
   the same. Calls go to 96250 05931 (the PHONE constant and the `tel` variable);
   WhatsApp stays on 96250 05931 (`wa`). Do not collapse them back into one.

   Built to claude/Jagdish-Wallpaper-Calculator-DECISIONS-LOCKED-19Sep2026.
   Every rule here was decided by AK on 19 Sep 2026, one question at a time.

   Its own component, like the curtain calculator. It borrows that calculator's
   stylesheet (assets/jagdish-curtain.css, the .jgc classes) so the two read as
   one family, and adds only what is new in assets/jagdish-wallpaper.css.

   TWO WAYS TO BUY
     Printed to my wall (custom mural) — sold in whole sq ft of print.
       Print size = wall + 5 cm on every side, or + 10 cm on every side when the
       wall is wider than 600 cm or taller than 350 cm. Shown as "included".
       Sq ft = print W x print H / 929.0304, per wall, Jagdish 0.3 rounding.
       Rate = the chosen material variant's own price per sq ft.
     Designer rolls — sold in whole rolls.
       Cut drop       = wall height + 10 cm
       Straight/half  : cut drop rounded up to a whole pattern repeat
       Free match     : no repeat rounding
       Drops per roll = floor(roll length / cut drop)
       Drops per wall = ceil(wall width / roll width)
       Rolls per wall = ceil(drops / drops per roll)   <- rounded PER WALL (AK)
       Rolls          = sum of walls + 1 spare, + 1 more for half-drop
       Roll width, length, repeat and match come from the product, never typed.

   ALWAYS
     Several walls, openings never subtracted. Minimum wall 60 x 60 cm.
     Hanging: 25 per sq ft of WALL, GST included, NCR cities only.
     GST 18% on wallpaper (HSN 4814) and hanging, INCLUDED in every price —
     shown as "includes", never added on top (the store is tax-inclusive).
     Lead time 7-10 working days, Sundays excluded.

   Revert: delete this file, assets/jagdish-wallpaper.css and
   snippets/jagdish-wallpaper.liquid, and remove the render tags. */
(function () {
  "use strict";

  var GST = 18;
  var MIN_SIDE = 60;
  var TRIM = 10;               /* cm added to every roll drop for trimming */
  var BLEED = 5;               /* cm each side on a custom print */
  var BLEED_BIG = 10;          /* cm each side on a big wall */
  var BIG_W = 600, BIG_H = 350;
  var SQFT = 929.0304;         /* cm2 in one square foot */
  var STD_ROLL_W = 53, STD_ROLL_L = 1000;
  var LEAD_TIME = "7–10 working days (Sundays excluded)";
  /* Rev 1.1 (AK, 10 Oct 2026): the CALL number, deliberately NOT the WhatsApp one. */
  var PHONE = "+91 96250 05931";
  var TEL = "919625005931";

  var CITIES = [
    { id: "delhi", label: "Delhi", hang: true },
    { id: "gurugram", label: "Gurugram", hang: true },
    { id: "noida", label: "Noida", hang: true },
    { id: "faridabad", label: "Faridabad", hang: true },
    { id: "ghaziabad", label: "Ghaziabad", hang: true },
    { id: "other", label: "Somewhere else", hang: false }
  ];

  var MODES = {
    mural: { label: "Printed to my wall", tab: "Printed to my wall" },
    roll: { label: "Designer rolls", tab: "Designer rolls" }
  };

  /* ------------------------------------------------------------------ helpers */

  function inr(n) { return "₹" + Math.round(n).toLocaleString("en-IN"); }

  /* AK's 0.3 rounding for measured quantities. Never zero. */
  function r03(x) {
    var f = x - Math.floor(x);
    var r = f < 0.3 ? Math.floor(x) : Math.ceil(x);
    return (r < 1 && x > 0) ? 1 : r;
  }

  function num(v) {
    var n = parseFloat(String(v == null ? "" : v).replace(",", "."));
    return isNaN(n) ? 0 : n;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* GST sitting INSIDE a tax-inclusive price */
  function gstInside(amount, rate) { return amount * rate / (100 + rate); }

  function matchKey(s) {
    s = String(s || "").toLowerCase();
    if (s.indexOf("half") > -1 || s.indexOf("offset") > -1) return "half";
    if (s.indexOf("free") > -1 || s.indexOf("random") > -1) return "free";
    return "straight";
  }
  var MATCH_LABEL = { straight: "Straight match", half: "Half-drop (offset)", free: "Free match" };

  /* --------------------------------------------------------------- the maths */

  function wallArea(w) { return r03(num(w.w) * num(w.h) / SQFT); }

  function checkWall(w) {
    var W = num(w.w), H = num(w.h);
    if (!W || !H) return { empty: true };
    if (W < MIN_SIDE || H < MIN_SIDE) {
      return { blocked: "We quote walls from 60 × 60 cm upwards. Yours is smaller, so let us quote it for you personally." };
    }
    return null;
  }

  function costMuralWall(w) {
    var chk = checkWall(w); if (chk) return chk;
    var W = num(w.w), H = num(w.h);
    var b = (W > BIG_W || H > BIG_H) ? BLEED_BIG : BLEED;
    var pw = W + 2 * b, ph = H + 2 * b;
    return {
      sqft: r03(pw * ph / SQFT),
      area: wallArea(w),
      bleed: b,
      label: W + " × " + H + " cm",
      print: pw + " × " + ph + " cm"
    };
  }

  function costRollWall(w, spec) {
    var chk = checkWall(w); if (chk) return chk;
    var W = num(w.w), H = num(w.h);
    var cut = H + TRIM;
    if (spec.match !== "free" && spec.repeat > 0) cut = Math.ceil(cut / spec.repeat) * spec.repeat;
    var perRoll = Math.floor(spec.length / cut);
    if (perRoll < 1) {
      return { blocked: "At this wall height one roll of this paper cannot give a single full drop. We can order a longer roll for you, so let us quote it personally." };
    }
    var drops = Math.ceil(W / spec.width);
    return {
      rolls: Math.ceil(drops / perRoll),
      drops: drops,
      perRoll: perRoll,
      cut: cut,
      area: wallArea(w),
      label: W + " × " + H + " cm"
    };
  }

  /* ------------------------------------------------- the measuring sketch

     Black-and-white line drawing in the same hand as the curtain diagram. Width
     at the widest point, height from skirting to ceiling measured in three
     places. The mural version shows the print running past the wall edge; the
     roll version shows the paper going up in vertical drops. */

  function diagram(mode) {
    var mural = mode === "mural";
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 300 250");
    svg.setAttribute("class", "jgc-diagram");
    svg.setAttribute("role", "img");
    svg.setAttribute("aria-label", "Measure the wall width at its widest point, and the height from skirting to ceiling in three places. Use the largest figures.");

    var parts = [
      '<g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">',
      /* ceiling and floor */
      '<line x1="14" y1="40" x2="286" y2="40" stroke-width="2"/>',
      '<line x1="14" y1="206" x2="286" y2="206" stroke-width="2"/>',
      /* the wall */
      '<rect x="50" y="40" width="200" height="166"/>',
      /* skirting board, a clear band at the foot of the wall */
      '<line x1="50" y1="192" x2="250" y2="192"/>'
    ];

    if (mural) {
      /* the print, larger than the wall all round */
      parts.push('<rect x="43" y="33" width="214" height="180" stroke-dasharray="4 4"/>');
      parts.push('<path d="M70 150 C 100 110, 130 170, 160 120 S 220 90, 235 130" stroke-width="1.2"/>');
      parts.push('<circle cx="110" cy="92" r="14" stroke-width="1.2"/>');
    } else {
      /* vertical drops of paper: faint seams, so they never read as arrows */
      [90, 130, 170, 210].forEach(function (x) {
        parts.push('<line x1="' + x + '" y1="40" x2="' + x + '" y2="192" stroke-dasharray="1 4" stroke-width="1" opacity=".4"/>');
      });
    }

    /* width arrow, at the widest point */
    parts.push('<line x1="50" y1="22" x2="250" y2="22" stroke-dasharray="5 4"/>');
    parts.push('<path d="M57 17 L50 22 L57 27"/><path d="M243 17 L250 22 L243 27"/>');

    /* three height arrows */
    [72, 150, 228].forEach(function (x) {
      parts.push('<line x1="' + x + '" y1="46" x2="' + x + '" y2="186" stroke-dasharray="5 4" stroke-width="1.2"/>');
      parts.push('<path d="M' + (x - 4) + ' 52 L' + x + ' 46 L' + (x + 4) + ' 52"/>');
      parts.push('<path d="M' + (x - 4) + ' 180 L' + x + ' 186 L' + (x + 4) + ' 180"/>');
    });

    parts.push('</g>');
    parts.push('<g fill="currentColor" font-size="11" font-family="inherit">');
    parts.push('<text x="150" y="13" text-anchor="middle">Wall width, at the widest point</text>');
    parts.push('<text x="150" y="226" text-anchor="middle">Height, skirting to ceiling, in 3 places.</text>');
    parts.push('<text x="150" y="240" text-anchor="middle">' + (mural ? "Use the largest. We add the margin." : "Use the largest. We add the trim.") + '</text>');
    parts.push('</g>');

    svg.innerHTML = parts.join("");
    return svg;
  }

  /* ---------------------------------------------------------------- the build */

  function boot(root) {
    if (root.getAttribute("data-ready")) return;
    root.setAttribute("data-ready", "1");

    var d = root.dataset;
    var productMode = d.mode === "product";
    var wa = (d.wa || "919625005931").replace(/[^0-9]/g, "");
    /* Rev 1.1 (AK, 10 Oct 2026): the CALL number, deliberately NOT the WhatsApp one. */
    var tel = (d.tel || TEL).replace(/[^0-9]/g, "");
    var visit = d.visit || "/pages/design-visit";
    var hangRate = num(d.hangrate) || 25;
    var hangVariant = d.hangvariant || "";
    /* Rev 2.3 (AK, 25 Oct 2026, 11:26 IST): designer ROLLS are installed at Rs 850 for every roll
       hung, premium glue included — part of a roll counts as a whole roll. The spare roll is not
       hung, so it is not charged. MURALS per sq ft of wall at Rs 20 (the "Wallpaper Hanging – per
       sq ft" product). Both rates are read from their products, never typed here. */
    var instRate = num(d.instrate) || 0;
    var instVariant = d.instvariant || "";

    var variants = [];
    var vjson = root.querySelector("script.jgw-variants");
    try { variants = JSON.parse(vjson ? vjson.textContent : "[]"); } catch (e) { variants = []; }

    var spec = {
      width: num(d.rollw),
      length: num(d.rolll),
      repeat: num(d.repeat),
      match: matchKey(d.match),
      material: d.material || "",
      gsm: d.gsm || "",
      finish: d.finish || ""
    };
    var specKnown = spec.width > 0 && spec.length > 0;

    var state = {
      mode: d.wpmode === "roll" ? "roll" : "mural",
      variant: variants.length ? String(variants[0].id) : "",
      rate: 0,
      city: "",
      walls: [blankWall()]
    };

    function blankWall() { return { w: "", h: "", open: true }; }

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === state.variant) return variants[i];
      return variants[0] || null;
    }

    function rate() {
      if (productMode) { var v = currentVariant(); return v ? num(v.price) : 0; }
      return state.rate;
    }

    /* The roll spec on the Studio page, where no design is chosen yet: a
       standard 53 cm x 10 m roll with no pattern repeat. The design's own page
       gives the exact count for its pattern. */
    function rollSpec() {
      if (productMode && specKnown) return spec;
      return { width: STD_ROLL_W, length: STD_ROLL_L, repeat: 0, match: "free", standard: true };
    }

    var wrap = el("div", "jgc__wrap");
    var tabs = el("div", "jgw__tabs");
    var ref = el("div", "jgw__ref");
    var wallsBox = el("div", "jgc__windows");
    var addBtn = el("button", "jgc__add", "Another wall to do?");
    addBtn.type = "button";
    var choiceBox = el("div", "jgc__ratebox");
    var cityBox = el("div", "jgc__citybox");
    var out = el("div", "jgc__out");

    if (!productMode) wrap.appendChild(tabs);
    wrap.appendChild(ref);
    wrap.appendChild(wallsBox);
    wrap.appendChild(addBtn);
    wrap.appendChild(choiceBox);
    wrap.appendChild(cityBox);
    wrap.appendChild(out);
    root.appendChild(wrap);

    addBtn.addEventListener("click", function () {
      state.walls.forEach(function (w) { w.open = false; });
      state.walls.push(blankWall());
      drawWalls();
      recalc();
    });

    /* ------- fields ------- */

    function field(parent, label, hint, node) {
      var id = "jgw" + Math.random().toString(36).slice(2, 8);
      node.id = id;
      var f = el("div", "jgc__f");
      var l = el("label");
      l.htmlFor = id;
      l.textContent = label;
      if (hint) l.appendChild(el("span", "jgc__hint", " " + hint));
      f.appendChild(l);
      f.appendChild(node);
      parent.appendChild(f);
      return node;
    }

    function textInput(value, placeholder) {
      var i = el("input");
      i.type = "text";
      i.inputMode = "decimal";
      i.autocomplete = "off";
      i.setAttribute("pattern", "[0-9]*[.,]?[0-9]*");
      i.value = value == null ? "" : value;
      if (placeholder) i.placeholder = placeholder;
      return i;
    }

    function select(options, selected) {
      var s = el("select");
      options.forEach(function (o) {
        var op = el("option", null, o.label);
        op.value = o.id;
        if (String(o.id) === String(selected)) op.selected = true;
        s.appendChild(op);
      });
      return s;
    }

    /* ------- Studio tabs: the two ways to buy ------- */

    function drawTabs() {
      tabs.textContent = "";
      tabs.setAttribute("role", "tablist");
      ["mural", "roll"].forEach(function (m) {
        var b = el("button", "jgw__tab", MODES[m].tab);
        b.type = "button";
        b.setAttribute("role", "tab");
        b.setAttribute("aria-selected", state.mode === m ? "true" : "false");
        b.addEventListener("click", function () {
          if (state.mode === m) return;
          state.mode = m;
          state.rate = 0;
          drawTabs(); drawRef(); drawWalls(); drawChoice(); recalc();
        });
        tabs.appendChild(b);
      });
    }

    /* ------- the reference card: what you are ordering ------- */

    function specRow(dl, k, v) {
      if (!v) return;
      dl.appendChild(el("dt", null, k));
      dl.appendChild(el("dd", null, v));
    }

    function drawRef() {
      ref.textContent = "";
      var mural = state.mode === "mural";
      var card = el("div", "jgw__card");

      if (productMode && d.image) {
        var img = el("img", "jgw__thumb");
        img.src = d.image;
        img.alt = d.title || "Your wallpaper";
        img.width = 80; img.height = 80;
        img.loading = "lazy";
        card.appendChild(img);
      }

      var body = el("div", "jgw__cardbody");
      body.appendChild(el("p", "jgw__eyebrow", mural ? "Printed to your wall" : "Designer rolls"));
      body.appendChild(el("p", "jgw__name", productMode ? (d.title || "") : (mural ? "Any design, printed to the size of your wall" : "Wallpaper sold in whole rolls")));

      var dl = el("dl", "jgw__spec");
      if (mural) {
        var v = currentVariant();
        specRow(dl, "Material", productMode ? (v ? v.title : spec.material) : "Non-woven or vinyl (washable)");
        specRow(dl, "Weight", spec.gsm ? spec.gsm + (/gsm/i.test(spec.gsm) ? "" : " GSM") : "");
        specRow(dl, "Finish", spec.finish);
        specRow(dl, "Made as", "Panels printed to your wall, with a margin all round for trimming");
      } else {
        var rs = rollSpec();
        specRow(dl, "Material", spec.material);
        specRow(dl, "Weight", spec.gsm ? spec.gsm + (/gsm/i.test(spec.gsm) ? "" : " GSM") : "");
        specRow(dl, "Finish", spec.finish);
        specRow(dl, "Roll", rs.width + " cm × " + (rs.length / 100) + " m" + (rs.standard ? " (standard roll)" : ""));
        if (!rs.standard) specRow(dl, "Pattern", rs.repeat > 0 && rs.match !== "free" ? rs.repeat + " cm repeat · " + MATCH_LABEL[rs.match] : MATCH_LABEL[rs.match] + " · no repeat to allow for");
      }
      specRow(dl, "Ready in", LEAD_TIME);
      body.appendChild(dl);

      card.appendChild(body);
      ref.appendChild(card);

      if (productMode && state.mode === "roll" && !specKnown) {
        ref.appendChild(el("p", "jgc__warn", "We are still adding this paper's roll size. Send us your walls and we will count the rolls for you."));
      }
    }

    /* ------- one wall ------- */

    function drawWall(w, index) {
      var card = el("div", "jgc__win" + (w.open ? " is-open" : ""));

      if (state.walls.length > 1) {
        var head = el("button", "jgc__winhead");
        head.type = "button";
        var sum = num(w.w) && num(w.h) ? w.w + " × " + w.h + " cm" : "Tap to enter sizes";
        head.appendChild(el("span", "jgc__winname", "Wall " + (index + 1)));
        head.appendChild(el("span", "jgc__winsum", sum));
        head.addEventListener("click", function () { w.open = !w.open; drawWalls(); });
        card.appendChild(head);
      }

      var body = el("div", "jgc__winbody");
      var p = el("div", "jgc__pair");
      body.appendChild(p);
      var wi = field(p, "Wall width", "cm", textInput(w.w, "e.g. 400"));
      var hi = field(p, "Wall height", "cm", textInput(w.h, "e.g. 270"));

      if (index === 0) {
        var guide = el("div", "jgc__guide");
        guide.appendChild(diagram(state.mode));
        body.appendChild(guide);
        body.appendChild(el("p", "jgc__why", "Doors and windows are never taken off. The paper around their frames is what keeps the pattern matching."));
      }

      wi.addEventListener("input", function () { w.w = wi.value; recalc(); });
      hi.addEventListener("input", function () { w.h = hi.value; recalc(); });

      if (state.walls.length > 1) {
        var rm = el("button", "jgc__remove", "Remove this wall");
        rm.type = "button";
        rm.addEventListener("click", function () {
          state.walls.splice(index, 1);
          if (!state.walls.length) state.walls.push(blankWall());
          drawWalls(); recalc();
        });
        body.appendChild(rm);
      }

      card.appendChild(body);
      return card;
    }

    function drawWalls() {
      wallsBox.textContent = "";
      state.walls.forEach(function (w, i) { wallsBox.appendChild(drawWall(w, i)); });
      addBtn.textContent = state.walls.length > 1 ? "Add another wall" : "Another wall to do?";
    }

    /* ------- material (product) or rate (Studio) ------- */

    function drawChoice() {
      choiceBox.textContent = "";
      if (productMode) {
        if (state.mode === "mural" && variants.length > 1) {
          var s = field(choiceBox, "Material", "", select(variants.map(function (v) {
            return { id: v.id, label: v.title + " — " + inr(num(v.price)) + " per sq ft" };
          }), state.variant));
          s.addEventListener("change", function () { state.variant = s.value; drawRef(); recalc(); });
        }
        return;
      }
      var unit = state.mode === "mural" ? "per sq ft" : "per roll";
      var f = field(choiceBox, "Price of the design", unit + ", optional", textInput(state.rate || "", "Take this from the design's page"));
      f.addEventListener("input", function () { state.rate = num(f.value); recalc(); });
    }

    function drawCity() {
      cityBox.textContent = "";
      var opts = [{ id: "", label: "Choose your city" }].concat(CITIES.map(function (c) { return { id: c.id, label: c.label }; }));
      var s = field(cityBox, "Where are we hanging it", "", select(opts, state.city));
      s.addEventListener("change", function () { state.city = s.value; recalc(); });
    }

    /* ------- WhatsApp text and the help block ------- */

    function waLink(message) { return "https://wa.me/" + wa + "?text=" + encodeURIComponent(message); }

    function summaryText(result) {
      var mural = state.mode === "mural";
      var bits = ["Hello Jagdish Store, here are my wallpaper measurements:"];
      bits.push((productMode && d.title ? "Design: " + d.title + " · " : "") + MODES[state.mode].label
        + (mural && productMode && currentVariant() ? " · " + currentVariant().title : ""));
      state.walls.forEach(function (w, i) {
        if (!num(w.w) || !num(w.h)) return;
        bits.push("Wall " + (i + 1) + ": " + w.w + " x " + w.h + " cm");
      });
      if (result && result.qty) bits.push("Estimate: " + result.qty + (result.total ? " · " + inr(result.total) + " incl. GST" : ""));
      for (var k = 0; k < CITIES.length; k++) if (CITIES[k].id === state.city) bits.push("City: " + CITIES[k].label);
      if (productMode && d.url) bits.push(d.url);
      return bits.join("\n");
    }

    function helpBlock(stopped, result) {
      var h = el("div", "jgc__help");
      h.appendChild(el("p", "jgc__helplead", stopped
        ? "Send us your walls and our specialist will go over them with you. Nothing is ever printed or cut on a guess."
        : "Happy with the numbers? Before anything is printed or cut, our specialist calls you and confirms every measurement with you."));
      var row = el("div", "jgc__helprow");
      var waBtn = el("a", "jgc__cta", "Send my sizes on WhatsApp");
      waBtn.href = waLink(summaryText(result));
      waBtn.rel = "noopener";
      waBtn.target = "_blank";
      row.appendChild(waBtn);
      var call = el("a", "jgc__ghost", "Call " + PHONE);
      call.href = "tel:+" + tel;
      row.appendChild(call);
      var book = el("a", "jgc__ghost", "Have us come and measure");
      book.href = visit;
      row.appendChild(book);
      h.appendChild(row);
      h.appendChild(el("p", "jgc__fine", "In-home service is free across Delhi NCR."));
      return h;
    }

    function row(name, meta, val) {
      var r = el("div", "jgc__row");
      var left = el("div");
      left.appendChild(el("span", "jgc__rowname", name));
      if (meta) left.appendChild(el("div", "jgc__rowmeta", meta));
      r.appendChild(left);
      r.appendChild(el("span", "jgc__rowval", val));
      return r;
    }

    /* ------- the estimate ------- */

    function recalc() {
      out.textContent = "";
      var mural = state.mode === "mural";

      if (!mural && productMode && !specKnown) {
        if (state.walls.some(function (w) { return num(w.w) && num(w.h); })) {
          var bb = el("div", "jgc__blocked");
          bb.appendChild(el("p", null, "We will count the rolls for this paper personally. Send us your walls."));
          bb.appendChild(helpBlock(true, null));
          out.appendChild(bb);
        }
        return;
      }

      var rs = rollSpec();
      var costed = state.walls.map(function (w) { return mural ? costMuralWall(w) : costRollWall(w, rs); });
      var blocked = costed.filter(function (c) { return c && c.blocked; });
      if (blocked.length) {
        var b = el("div", "jgc__blocked");
        b.appendChild(el("p", null, blocked[0].blocked));
        b.appendChild(helpBlock(true, null));
        out.appendChild(b);
        return;
      }
      var real = costed.filter(function (c) { return c && !c.empty; });
      if (!real.length) return;

      var price = rate();
      var showMoney = price > 0;
      var lines = [];
      var wallSq = real.reduce(function (n, c) { return n + c.area; }, 0);

      /* summary strip: the same thing the customer and our team will both see */
      var strip = el("div", "jgw__strip");
      if (productMode && d.image) {
        var t = el("img", "jgw__stripimg");
        t.src = d.image; t.alt = ""; t.width = 48; t.height = 48; t.loading = "lazy";
        strip.appendChild(t);
      }
      var st = el("div");
      st.appendChild(el("p", "jgw__stripname", productMode && d.title ? d.title : MODES[state.mode].label));
      st.appendChild(el("p", "jgw__stripmeta",
        (mural && productMode && currentVariant() ? currentVariant().title + " · " : "") +
        real.map(function (c) { return c.label; }).join(" · ")));
      strip.appendChild(st);
      out.appendChild(strip);

      var qtyText;
      if (mural) {
        var sq = real.reduce(function (n, c) { return n + c.sqft; }, 0);
        var anyBig = real.some(function (c) { return c.bleed === BLEED_BIG; });
        var allBig = real.every(function (c) { return c.bleed === BLEED_BIG; });
        var margin = allBig ? "10" : (anyBig ? "5–10" : "5");
        qtyText = sq + " sq ft";
        lines.push({
          name: "Wallpaper, printed to your wall",
          meta: sq + " sq ft · " + real.map(function (c) { return c.print; }).join(" · ")
                + " · " + margin + " cm margin all round, included",
          val: showMoney ? inr(sq * price) : qtyText,
          amount: sq * price,
          qty: sq
        });
      } else {
        var perWall = real.reduce(function (n, c) { return n + c.rolls; }, 0);
        var spares = rs.match === "half" ? 2 : 1;
        var rolls = perWall + spares;
        qtyText = rolls + " roll" + (rolls > 1 ? "s" : "");
        lines.push({
          name: showMoney ? "Wallpaper — " + qtyText : "Wallpaper",
          meta: real.map(function (c, i) { return "Wall " + (i + 1) + ": " + c.rolls + " roll" + (c.rolls > 1 ? "s" : ""); }).join(" · ")
                + " · + " + (spares === 2 ? "2 spare rolls, as half-drop patterns use more paper" : "1 spare roll"),
          val: showMoney ? inr(rolls * price) : qtyText,
          amount: rolls * price,
          qty: rolls
        });
      }

      var city = null;
      for (var ci = 0; ci < CITIES.length; ci++) if (CITIES[ci].id === state.city) city = CITIES[ci];
      var hanging = city && city.hang;
      var hangAmt = 0;
      if (hanging && !mural && instVariant && instRate > 0) {
        /* rolls actually hung — whole rolls per wall, the spare roll left out */
        var hungRolls = real.reduce(function (n, c) { return n + c.rolls; }, 0);
        hangAmt = hungRolls * instRate;
        lines.push({
          name: "Installation in " + city.label,
          meta: hungRolls + " roll" + (hungRolls > 1 ? "s" : "") + " hung × " + inr(instRate) + " a roll · premium glue included · part of a roll counts as a full roll · our own installers",
          val: inr(hangAmt),
          amount: hangAmt,
          qty: hungRolls,
          variant: instVariant,
          isHang: true
        });
      } else if (hanging) {
        hangAmt = wallSq * hangRate;
        lines.push({
          name: "Installation in " + city.label,
          meta: wallSq + " sq ft of wall · " + inr(hangRate) + " per sq ft · premium glue included",
          val: inr(hangAmt),
          amount: hangAmt,
          qty: wallSq,
          variant: hangVariant,
          isHang: true
        });
      }

      lines.forEach(function (l) { out.appendChild(row(l.name, l.meta, l.val)); });

      var total = 0;
      lines.forEach(function (l) { total += l.amount; });
      if (showMoney || hanging) {
        var tot = el("div", "jgc__total");
        tot.appendChild(el("span", null, showMoney ? "Total" : "Installation total"));
        tot.appendChild(el("span", null, inr(showMoney ? total : hangAmt)));
        out.appendChild(tot);
        var g = el("div", "jgc__sub");
        g.appendChild(el("span", null, "Includes GST at 18%"));
        g.appendChild(el("span", null, inr(gstInside(showMoney ? total : hangAmt, GST))));
        out.appendChild(g);
      }
      if (!showMoney && !productMode) {
        out.appendChild(el("p", "jgc__note", "Add the design's price to see what this comes to. You will find it on the design's own page."));
      }

      if (city && !city.hang) {
        out.appendChild(el("p", "jgc__warn", "We can make and deliver your wallpaper anywhere. Installation is only available in Delhi NCR at the moment."));
      } else if (!city) {
        out.appendChild(el("p", "jgc__note", "Choose your city to add installation by our own installers \u2014 " + (mural ? inr(hangRate) + " per sq ft of wall" : (instRate ? inr(instRate) + " for every roll hung, premium glue included" : "priced per wall")) + "."));
      }

      if (!mural && rs.standard) {
        out.appendChild(el("p", "jgc__note", "Counted on a standard 53 cm × 10 m roll with no pattern repeat. Each design's own page gives the exact count for its pattern."));
      }

      var copy = el("div", "jgc__copy");
      if (mural) {
        copy.appendChild(el("p", "jgc__copyhead", "Printed for your wall, and only yours"));
        copy.appendChild(el("p", null, "Printed to your wall, so it can't be returned. Our specialist confirms every size with you before we print."));
      } else {
        copy.appendChild(el("p", "jgc__copyhead", "Why a spare roll"));
        copy.appendChild(el("p", null, "Every print run is a little different. A spare roll from the same batch means a torn drop never means papering the wall again. Check every roll carries the same batch number before hanging. Unopened rolls follow our normal return policy."));
      }
      out.appendChild(copy);

      if (mural) {
        var own = el("p", "jgc__note");
        own.appendChild(document.createTextNode("Have your own design, a photograph or an artwork? "));
        var ol = el("a", null, "Send it on WhatsApp");
        ol.href = waLink("Hello Jagdish Store, I would like my own design printed as wallpaper. My walls:\n" + real.map(function (c, i) { return "Wall " + (i + 1) + ": " + c.label; }).join("\n"));
        ol.rel = "noopener"; ol.target = "_blank";
        own.appendChild(ol);
        own.appendChild(document.createTextNode(" and we will check it prints well at your size."));
        out.appendChild(own);
      }

      out.appendChild(el("p", "jgc__note", "See it in person at Shops 21–24, Ireo City Centre, Sector 59, Gurugram 122101."));
      out.appendChild(el("p", "jgc__lead", "Made and delivered in about " + LEAD_TIME + "."));

      var result = { qty: qtyText, total: showMoney ? total : 0 };
      out.appendChild(helpBlock(false, result));
      out.appendChild(orderRoutes(lines, result));
    }

    /* ------- ordering routes: product pages only ------- */

    function orderRoutes(lines, result) {
      if (!productMode) return document.createDocumentFragment();

      /* 20 Sep 2026 (AK): "Order now" first, above every other button (drawn by
         assets/jagdish-order.js). It orders what the total shows: the wallpaper,
         plus hanging when the estimate includes it. */
      var hang0 = lines.filter(function (l) { return l.isHang; })[0];
      if (window.JGOrder && result && result.total > 0) {
        window.JGOrder.button(out, function (btn) { addToCart(lines[0], hang0 && (hang0.variant || hangVariant) ? hang0 : null, btn, true); });
      }

      var box = el("div", "jgc__routes");

      var a = el("a", "jgc__route", "Send my sizes on WhatsApp");
      a.href = waLink(summaryText(result));
      a.rel = "noopener"; a.target = "_blank";
      box.appendChild(a);

      var hang = lines.filter(function (l) { return l.isHang; })[0];
      if (hang && (hang.variant || hangVariant)) {
        var b = el("button", "jgc__route", "Add the wallpaper and installation to my basket");
        b.type = "button";
        b.addEventListener("click", function () { addToCart(lines[0], hang, b, false); });
        box.appendChild(b);
      }
      var c = el("button", "jgc__route", hang ? "Add the wallpaper only — installation is not included" : "Add the wallpaper to my basket");
      c.type = "button";
      c.addEventListener("click", function () { addToCart(lines[0], null, c, false); });
      box.appendChild(c);
      return box;
    }

    function addToCart(paper, hang, btn, direct) {
      var v = state.mode === "mural" ? state.variant : d.variant;
      if (!v || !paper.qty) return;
      var props = {
        "Walls": state.walls.filter(function (w) { return num(w.w) && num(w.h); })
          .map(function (w, i) { return "Wall " + (i + 1) + " " + w.w + " x " + w.h + " cm"; }).join(" | "),
        "How it is made": MODES[state.mode].label
      };
      var items = [{ id: Number(v), quantity: paper.qty, properties: props }];
      if (hang && (hang.variant || hangVariant)) items.push({ id: Number(hang.variant || hangVariant), quantity: hang.qty, properties: props });
      if (window.JGOrder) { window.JGOrder.send(items, { direct: !!direct, button: btn }); return; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (r.ok) window.location.href = "/cart";
      }).catch(function () { /* the WhatsApp route is always there */ });
    }

    drawTabs();
    drawRef();
    drawWalls();
    drawChoice();
    drawCity();
    recalc();
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll(".jgw:not([data-ready])"), boot);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  /* Shopify re-renders the product section on a variant change. Re-boot cheaply. */
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        if (document.querySelector(".jgw:not([data-ready])")) start();
      }, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
